import React, { useState, useEffect } from 'react';
import { Icon } from 'semantic-ui-react';
import './SelectionFeedback.css';

const SelectionFeedback = ({ 
  selectedCount = 0, 
  multiSelectedCount = 0, 
  totalItems = 0,
  lastAction = null 
}) => {
  const [showFeedback, setShowFeedback] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState('');

  useEffect(() => {
    if (lastAction) {
      let message = '';
      
      switch (lastAction.type) {
        case 'select':
          message = `Selected ${lastAction.count} item${lastAction.count !== 1 ? 's' : ''}`;
          break;
        case 'deselect':
          message = 'Selection cleared';
          break;
        case 'select_all':
          message = `Selected all ${totalItems} items`;
          break;
        case 'multi_select':
          message = `${multiSelectedCount} items selected`;
          break;
        default:
          return;
      }
      
      setFeedbackMessage(message);
      setShowFeedback(true);
      
      // Auto-hide after 2 seconds
      const timer = setTimeout(() => {
        setShowFeedback(false);
      }, 2000);
      
      return () => clearTimeout(timer);
    }
  }, [lastAction, totalItems, multiSelectedCount]);

  if (!showFeedback) return null;

  return (
    <div className="selection-feedback">
      <div className="feedback-content">
        <Icon name="check circle" color="teal" />
        <span>{feedbackMessage}</span>
      </div>
    </div>
  );
};

export default SelectionFeedback;